import { IApiResponse } from "common//models";
import { API_CONFIG, LOCAL_URL, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";
import {
  IArgsCountry,
  IArgsCountries,
  IArgsCurrency,
  IArgsCurrencies,
  IArgsState,
  IArgsStates,
  IArgsRegion,
  IArgsRegions,
  IArgsArea,
  IArgsAreas,
  IArgsUpdateAreas,
} from "./models";

interface IApiGeography {
  manageCountry: (args: IArgsCountry) => Promise<IApiResponse>;
  getCountries: (args: IArgsCountries) => Promise<IApiResponse>;
  manageCurrency: (args: IArgsCurrency) => Promise<IApiResponse>;
  getCurrencies: (args: IArgsCurrencies) => Promise<IApiResponse>;
  manageState: (args: IArgsState) => Promise<IApiResponse>;
  getStates: (args: IArgsStates) => Promise<IApiResponse>;
  manageRegion: (args: IArgsRegion) => Promise<IApiResponse>;
  getRegions: (args: IArgsRegions) => Promise<IApiResponse>;
  manageArea: (args: IArgsArea) => Promise<IApiResponse>;
  getAreas: (args: IArgsAreas) => Promise<IApiResponse>;
  updateAreas: (args: IArgsUpdateAreas) => Promise<IApiResponse>;

  getEventUsers: (args: IArgsUpdateAreas) => Promise<IApiResponse>;
  manageRoute: (args: IArgsUpdateAreas) => Promise<IApiResponse>;
}

const local = PRODUCTION === "false" && UAT === "false";

export class ApiGeography implements IApiGeography {
  manageCountry = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ge/v1/JDE1GNTQX8R7P0CK",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getCountries = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ge/v1/S01NITHGX73P2485",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageCurrency = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ge/v1/6LOUJ0REPNVKIWZ2",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getCurrencies = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ge/v1/3PTBOQVFCN2RMSE5",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageState = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ge/v1/C4G0O7RWMJKEUAL9",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getStates = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ge/v1/9IKC4SXAWPNUDHJ2",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageRegion = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ge/v1/R3D68EL7XUBZCY40",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getRegions = async (args: any, token = ""): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ge/v1/VGJ271ZTL5UQX0P8";
      if (local) {
        apiUrl = LOCAL_URL + ":8002" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageArea = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ge/v1/M74XT09R8DZ3O6JY";
      if (local) {
        apiUrl = LOCAL_URL + ":8002" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getAreas = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ge/v1/WTGU3BHRM08Z9XJI";
      if (local) {
        apiUrl = LOCAL_URL + ":8002" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  updateAreas = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/ge/v1/WTGU3BHRM08Z9XUA",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getEventUsers = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ge/v1/0ZGMK9PRYFHSAU1J";
      if (local) {
        apiUrl = LOCAL_URL + ":8002" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getRoutes = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ge/v1/VQI1LPUYG8R2K7AD";
      if (local) {
        apiUrl = LOCAL_URL + ":8002" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageRoute = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/ge/v1/KGWZ2RHA9EBI13UF";
      if (local) {
        apiUrl = LOCAL_URL + ":8002" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
}
